import { Gizmo } from '../../gizmos';
import { findGizmos } from '../../gizmos/utils';
import { IGizmo } from '../../types';
import CommonBinder from '../common-binder';

class SectionBinder extends CommonBinder {
  constructor(gizmo: Gizmo) {
    super(gizmo);
  }

  public init = (): Promise<void> => {
    return new Promise<void>(async resolve => {
      const newGizmos: Gizmo[] = [];

      const config = this._gizmo.getConfig();
      const features = this._gizmo.getFeatures();

      const buttonGizmos = findGizmos({
        gizmo: this._gizmo,
        type: 'button',
      });
      const foundNextButton = buttonGizmos.find(
        g => g.getConfig().ops?.button?.operation === 'section.next'
      );
      const foundBackButton = buttonGizmos.find(
        g => g.getConfig().ops?.button?.operation === 'section.back'
      );
      const foundSaveButton = buttonGizmos.find(
        // g => g.getConfig().ops?.button?.operation === 'form.save'
        g => g.getConfig().ops?.button?.operation === 'form.submit'
      );

      // It's the middle or the last section, not the first
      if (
        (features.section?.last === true ||
          features.section?.middle === true) &&
        !foundBackButton
      ) {
        const backButtonConfig: IGizmo = {
          fid: `back-button-${config.fid}`,
          type: 'button',
          label: 'Atras',
          uid: `added_back_button_${config.fid}`,
          ops: {
            button: {
              operation: 'section.back',
            },
          },
        };

        const backButton: Gizmo = new Gizmo({
          config: backButtonConfig,
          callbacks: this._gizmo.getCallbacks(),
          params: this._gizmo.getParams(),
          dao: this._gizmo.getDao(),
          ancestors: this._gizmo.getAncestors(),
          events: this._gizmo.getEvents(),
          rootGizmoCallbacks: this._gizmo.getRootGizmoCallbacks(),
        });
        await backButton.init();

        newGizmos.push(backButton);
      }

      // If it's the first or a section in the middle we add the button
      if (
        (features.section?.first === true ||
          features.section?.middle === true) &&
        !foundNextButton
      ) {
        const nextButtonConfig: IGizmo = {
          fid: `next-button-${config.fid}`,
          type: 'button',
          label: 'Siguiente',
          uid: `added_next_button_${config.fid}`,
          ops: {
            button: {
              operation: 'section.next',
            },
          },
        };
        const nextButton: Gizmo = new Gizmo({
          config: nextButtonConfig,
          callbacks: this._gizmo.getCallbacks(),
          params: this._gizmo.getParams(),
          dao: this._gizmo.getDao(),
          ancestors: this._gizmo.getAncestors(),
          events: this._gizmo.getEvents(),
          rootGizmoCallbacks: this._gizmo.getRootGizmoCallbacks(),
        });
        await nextButton.init();

        newGizmos.push(nextButton);
      }

      if (features.section?.last === true && !foundSaveButton) {
        const saveButtonConfig: IGizmo = {
          fid: `save-button-${config.fid}`,
          type: 'button',
          label: 'Guardar',
          uid: `added_save_button_${config.fid}`,
          ops: {
            button: {
              operation: 'form.submit',
            },
          },
        };

        const saveButton: Gizmo = new Gizmo({
          config: saveButtonConfig,
          callbacks: this._gizmo.getCallbacks(),
          params: this._gizmo.getParams(),
          dao: this._gizmo.getDao(),
          ancestors: this._gizmo.getAncestors(),
          events: this._gizmo.getEvents(),
          rootGizmoCallbacks: this._gizmo.getRootGizmoCallbacks(),
        });
        await saveButton.init();

        newGizmos.push(saveButton);
      }

      for (const newGizmo of newGizmos) {
        this._gizmo.getGizmos()?.push(newGizmo);
      }

      resolve();
    });
  };
}

export default SectionBinder;
